module.exports = __webpack_public_path__ + "static/netlify.85cd9fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/tech/netlify.png
// module id = 506
// module chunks = 114276838955818